import { render } from "./P032.vue?vue&type=template&id=b25ef626&scoped=true"
import script from "./P032.vue?vue&type=script&lang=js"
export * from "./P032.vue?vue&type=script&lang=js"

import "./P032.vue?vue&type=style&index=0&id=b25ef626&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b25ef626"]])

export default __exports__